import cx from 'classnames';
import PT from 'prop-types';
import style from './TabNav.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const Tab = ({ onClick, selected, label, disabled }) => {
  return (
    <button
      type="button"
      className={cx(style.tab, { [style.selected]: selected })}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

const TabNav = ({ onChange, items, selectedItemId }) => {
  return (
    <div className={style.container}>
      {items.map((item) => (
        <Tab
          key={item.id}
          onClick={() => onChange(item.id)}
          label={item.label}
          selected={item.id === selectedItemId}
          disabled={item.disabled}
        />
      ))}
    </div>
  );
};

TabNav.propTypes = {
  onChange: PT.func,
  items: PT.arrayOf(
    PT.shape({ id: PT.string, label: PT.string, disabled: PT.bool })
  ),
  selectedItemId: PT.string,
};

export default TabNav;
